module.exports = __webpack_public_path__ + "media/images/smart_phone/icons/img_aichi-9720a059ac7e8a56a241bc0632ae3c91.png";